import { useMemo } from 'react';
import { NotificationCount, loadConnectAndInitialize } from '@stripe/connect-js';
import { ConnectComponentsProvider, ConnectNotificationBanner } from '@stripe/react-connect-js';
import { fetchAccountStripeNotificationsSession } from 'api/account';
import { useStripeNotifications } from 'assets/js/pages/payouts/StripeNotificationsContext';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';

const StripeNotificationsBanner = () => {
    const { accountId } = useCurrentAccount();
    const {
        hasFetchedNotifications,
        setHasFetchedNotifications,
        hasNotifications,
        setHasNotifications,
    } = useStripeNotifications();

    const handleNotificationsChange = ({ total }: NotificationCount) => {
        if (total > 0) {
            setHasNotifications(true);
        }

        if (!hasFetchedNotifications) {
            setHasFetchedNotifications(true);
        }
    };

    const connectInstance = useMemo(
        () =>
            loadConnectAndInitialize({
                publishableKey: import.meta.env.VITE_DASHBOARD_STRIPE_CONNECT_KEY,
                fetchClientSecret: async () => {
                    const session = await fetchAccountStripeNotificationsSession(accountId);
                    if (session) {
                        return session.session_token;
                    }
                    throw new Error('Failed to fetch notification session token');
                },
            }),
        [accountId],
    );

    return (
        <ConnectComponentsProvider connectInstance={connectInstance}>
            <div className={twMerge(!hasNotifications && 'sr-only')}>
                <ConnectNotificationBanner onNotificationsChange={handleNotificationsChange} />
            </div>
        </ConnectComponentsProvider>
    );
};

export { StripeNotificationsBanner };
